<template>
	<div>
		<span v-if="salary?.not_specified">
			<BaseText class="text-dj-grey" type="p">{{ langs.salary_range[locale] }}</BaseText>
			<BaseText class="text-dj-grey" type="p" size="big">{{ langs.not_specified[locale] }}</BaseText>
		</span>
		<span v-else>
			<BaseText class="text-dj-grey mb-1" type="p">
				<span v-if="salary.amount_in">
					{{ salary.amount_in === "gross" ? langs.gross[locale] : langs.netto[locale] }}
					<span v-if="salary.salary_period === 'hour'" class="lowercase">{{ langs.per_hour[locale] }}</span>
					<span v-else-if="salary.salary_period === 'month'" class="lowercase">
						{{ langs.per_month[locale] }}
					</span>
					<span v-else-if="salary.salary_to != salary.salary_from">{{ langs.salary_range[locale] }}</span>
					<span v-else>{{ langs.salary[locale] }}</span>
				</span>
				<span v-else>
					<span v-if="salary.salary_to != salary.salary_from">{{ langs.salary_range[locale] }}</span>
					<span v-else>{{ langs.salary[locale] }}</span>
				</span>
			</BaseText>
			<BaseText class="flex" type="p" size="big">
				<span>{{ formattedSalaryFrom }}</span>
				<span class="mx-1" v-if="salary.salary_to && salary.salary_to != salary.salary_from">-</span>
				<span v-if="salary.salary_to && salary.salary_to != salary.salary_from">{{ formattedSalaryTo }}</span>
				<span class="block ml-1 w-10 overflow-hidden whitespace-nowrap overflow-ellipsis">
					{{ formattedCurrency }}
				</span>
			</BaseText>
		</span>
	</div>
</template>

<script lang="ts">
import BaseText from "~/ui-kit/components/BaseText.vue";

import { ref, defineComponent, computed, type PropType } from "vue";
import type { JobCardsLang } from "~/ui-kit/types/types";

export default defineComponent({
	name: "DjCardSalary",
	components: {
		BaseText,
	},
	props: {
		salary: {
			type: Object,
			default: () => {
				return {};
			},
		},
		langs: {
			type: Object as PropType<JobCardsLang["salary"]>,
			default: () => {
				return {};
			},
		},
		locale: {
			type: String,
			default: "hu",
		},
	},
	setup(props) {
		const formattedSalaryFrom = ref("");
		const formattedSalaryTo = ref("");

		const baseCurrencies = ["huf", "ron", "eur"];

		props.salary.salary_from
			? (formattedSalaryFrom.value = new Intl.NumberFormat("hu-HU", {}).format(props.salary.salary_from))
			: null;
		props.salary.salary_to
			? (formattedSalaryTo.value = new Intl.NumberFormat("hu-HU", {}).format(props.salary.salary_to))
			: null;

		const formattedCurrency = computed(() => {
			return baseCurrencies.includes(props.salary.currency)
				? props.salary.currency.toUpperCase()
				: props.salary.currency;
		});

		return {
			formattedSalaryFrom,
			formattedSalaryTo,
			formattedCurrency,
		};
	},
});
</script>
